import api from './api';

class DepartmentService {
  static async getDepartments(params = {}) {
    const response = await api.get('/departments', { params });
    return response.data;
  }

  static async getAvailableDepartments() {
    const response = await api.get('/departments/available');
    return response.data;
  }

  static async getDepartmentById(id) {
    const response = await api.get(`/departments/${id}`);
    return response.data;
  }

  static async createDepartment(data) {
    const response = await api.post('/departments', data);
    return response.data;
  }

  static async updateDepartment(id, data) {
    const response = await api.put(`/departments/${id}`, data);
    return response.data;
  }

  static async deleteDepartment(id) {
    const response = await api.delete(`/departments/${id}`);
    return response.data;
  }
}

export default DepartmentService;
